import { readAttachmentType, resolveAttachmentRenderer } from './registry'

// 一組工具呼叫下方的附件（#1620）。即時串流與重新整理後走同一條：
// 兩邊的 output 都是工具結果本身，所以卡片不必另外存一份。

export interface AttachmentSource {
  toolCallId: string
  state: string
  output?: unknown
}

interface ToolAttachmentsProps {
  parts: readonly AttachmentSource[]
  onOpen?: (id: string) => void
}

export function ToolAttachments({ parts, onOpen }: ToolAttachmentsProps) {
  const views = parts.flatMap((part) => {
    // 還在跑或失敗的那一支沒有結果可畫
    if (part.state !== 'output-available') return []
    const Renderer = resolveAttachmentRenderer(readAttachmentType(part.output))
    return Renderer ? [{ id: part.toolCallId, Renderer, content: part.output }] : []
  })
  if (views.length === 0) return null
  return (
    <div className="tool-attachments">
      {views.map(({ id, Renderer, content }) => (
        <Renderer key={id} content={content} onOpen={onOpen} />
      ))}
    </div>
  )
}
